import React from "react";
import { useSelector } from "react-redux";
import user from "../assets/img/user.png";

const MyImgRound = ({ image }) => {
    const employee = useSelector((state) => state.manager.employee);

    return (
        <div
            className="my-img-round"
            style={{
                backgroundImage: `url(${image || user})`,
            }}
        />
    );
};

export default MyImgRound;
